import { authFetch } from './authFetch';

export type EventItem = {
  id?: number;
  title: string;
  description?: string;
  start: string; // ISO string
  end: string;   // ISO string
  created_by?: string;
  created_at?: string;
  updated_at?: string;
};

export async function listEvents(): Promise<EventItem[]> {
  const res = await authFetch('/api/events/');
  if (!res.ok) throw new Error('Failed to fetch events');
  return res.json();
}

export async function createEvent(data: EventItem): Promise<EventItem> {
  const res = await authFetch('/api/events/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to create event');
  return res.json();
}

export async function updateEvent(id: number, data: Partial<EventItem>): Promise<EventItem> {
  const res = await authFetch(`/api/events/${id}/`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to update event');
  return res.json();
}

export async function deleteEvent(id: number): Promise<void> {
  const res = await authFetch(`/api/events/${id}/`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Failed to delete event');
}

